import TextUtil from "../../../../../lib/html5-software-library/src/ranj/components/text/TextUtil";
import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import LaptopNavigateEvent from "../../../ngt/laptop/model/LaptopNavigateEvent";
import FeedbackEvent from "../../feedback/event/FeedbackEvent";
import KeyDecisionInteractionEvent from "../../key-decisions/event/KeyDecisionInteractionEvent";
import KeyDecision from "../../key-decisions/model/KeyDecision";
import HubEvent from "../event/HubEvent";

export default class HubKeyDecisionListItemMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;

        /** @type {KeyDecision} */
        //this._keyDecision = this.getCustomData().keyDecision;
        this._keyDecision = null;

        this._handleRolloverBound = this._handleRollover.bind(this);
        this._handleRolloutBound = this._handleRollout.bind(this);

        this._isAvailable = false;
        this._isFeedbackMode = false;
        this._indexFeedback = 0;
    }

    initialize() {
        super.initialize();
        this.disable();
        this.registerEventListener(HubEvent.UNSELECT_KEY_DECISION_LIST_ITEM, this._handleUnselectKeyDecisionListItemHandle.bind(this));
    }

    initializeAsFeedback(indexFeedback) {
        this._isFeedbackMode = true;
        this._indexFeedback = indexFeedback;
    }

    _handleUnselectKeyDecisionListItemHandle() {
        if (this._target.currentFrame == HubKeyDecisionListItemMediator.MC_FRAME_SELECTED) {
            this.availableSeen();
        }
    }

    isAvailable() {
        return this._isAvailable;
    }

    hasKeyDecision() {
        return this._keyDecision !== null;
    }

    getKeyDecision() {
        return this._keyDecision;
    }

    initializeWithKeyDecision(keyDecision) {
        this._keyDecision = keyDecision;
        if (this._isFeedbackMode) {
            this._button_feedback = this.createButton(this._target.buttonFeedbackInactive.buttonFeedbackInactive, this._handleButton.bind(this));
        }
        this._button = this.createButton(this._target.button.button, this._handleButton.bind(this));
        this._button.addEventListener('rollover', this._handleRolloverBound);
        this._button.addEventListener('rollout', this._handleRolloutBound);
        this._target.panel2.alpha = 0;

        if (this._target.panel?.KDUnlockedText) {
            this._target.panel.KDUnlockedText.initialY = this._target.panel.KDUnlockedText.y;
            this._target.panel.KDUnlockedText.initialBounds = this._target.panel.KDUnlockedText.getBounds();
            this._target.panel.KDUnlockedText.text = this._languagePack.getText('keyDecisionsListItem.unlockNewKeyDecision');
            TextUtil.centerTextVertically(this._target.panel.KDUnlockedText, this._target.panel.KDUnlockedText.initialY, this._target.panel.KDUnlockedText.initialBounds.height);
        }


        if (this._target.panel2?.actionNeededTextField2) {
            this._target.panel2.actionNeededTextField2.initialY = this._target.panel2.actionNeededTextField2.y;
            this._target.panel2.actionNeededTextField2.initialBounds = this._target.panel2.actionNeededTextField2.getBounds();
            this._target.panel2.actionNeededTextField2.text = this._languagePack.getText(this._keyDecision.actionNeededLpKey);
            TextUtil.centerTextVertically(this._target.panel2.actionNeededTextField2, this._target.panel2.actionNeededTextField2.initialY, this._target.panel2.actionNeededTextField2.initialBounds.height);
        }

        this._target.loop = 0;
    }

    disable() {
        this._isAvailable = false;
        this._target.gotoAndStop(HubKeyDecisionListItemMediator.MC_FRAME_NOT_AVAILABLE);
    }

    availableUnseen() {
        this._isAvailable = true;
        this._target.gotoAndStop(HubKeyDecisionListItemMediator.MC_FRAME_NEW_ANIMATION);
        this._target.NewKDAnim.loop = 0;
        this._target.NewKDAnim.timeline.gotoAndPlay(0);
        this._target.NewKDAnim.timeline.on('change', (evt) => {
            if (this._target.NewKDAnim.timeline.paused) {
                evt.remove();
                // End of animation, Moving towards next step
                this._target.gotoAndStop(HubKeyDecisionListItemMediator.MC_FRAME_NEW);
                this.dispatch(LaptopNavigateEvent.SHOW_OVERLAY);
            }
        });
    }

    selected() {
        this._isAvailable = true;
        this._target.gotoAndStop(HubKeyDecisionListItemMediator.MC_FRAME_SELECTED);
        this._target.pointer.alpha = 0;
        this._target.pointer.scale = 0;
        createjs.Tween.get(this._target.pointer)
            .wait(750)
            .to({ alpha: 1, scale: 1 }, 450, createjs.Ease.backOut);
    }

    availableSeen() {
        this._isAvailable = true;
        this._target.gotoAndStop(HubKeyDecisionListItemMediator.MC_FRAME_AVAILABLE);
        this._target.panel2.alpha = 0;
    }

    isPerformed() {
        return this._target.currentFrame == HubKeyDecisionListItemMediator.MC_FRAME_PERFORMED;
    }

    getArc() {
        return this._keyDecision.arc;
    }

    performed() {
        this._isAvailable = false;
        this.destroyButton();
        this._target.gotoAndStop(HubKeyDecisionListItemMediator.MC_FRAME_PERFORMED);
    }

    destroyButton() {
        this._button.destroy();
        this._button = null;
    }

    destroy() {
        if (this._button !== null) {
            this.destroyButton();
        }
        super.destroy();
    }

    _handleButton() {
        if (!this._isFeedbackMode) {
            const keyDecisionInteractionEvent = new KeyDecisionInteractionEvent(KeyDecisionInteractionEvent.NOTIFY_KEY_DECISION_AVAILABLE, this._keyDecision);
            this._dispatcher.dispatch(keyDecisionInteractionEvent.type, { data: keyDecisionInteractionEvent });
            this.selected();
        } else {
            this._dispatcher.dispatch(FeedbackEvent.MOVE_TO_KD_REQUEST, { data: this._indexFeedback });
        }
    }

    _handleRollover() {
        createjs.Tween.get(this._target.panel2, { override: true })
            .to({ alpha: 1 }, 250, createjs.Ease.sineInOut);
    }

    _handleRollout() {
        createjs.Tween.get(this._target.panel2, { override: true })
            .to({ alpha: 0 }, 250, createjs.Ease.sineInOut);
    }

    get skin() {
        return this._target;
    }

    get keyDecision() {
        return this._keyDecision;
    }
}
HubKeyDecisionListItemMediator.MC_FRAME_NEW_ANIMATION = 0;
HubKeyDecisionListItemMediator.MC_FRAME_NEW = 1;
HubKeyDecisionListItemMediator.MC_FRAME_AVAILABLE = 3;
HubKeyDecisionListItemMediator.MC_FRAME_SELECTED = 4;
HubKeyDecisionListItemMediator.MC_FRAME_NOT_AVAILABLE = 5;
HubKeyDecisionListItemMediator.MC_FRAME_PERFORMED = 6;